import React from 'react';
import { useTranslation } from 'react-i18next';
import { searchSeries } from '../../api';
import UnifiedAutocomplete from './UnifiedAutocomplete';

interface SeriesAutocompleteProps {
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SeriesAutocomplete: React.FC<SeriesAutocompleteProps> = ({
  value,
  onChange,
  placeholder = "Search or enter a series..."
}) => {
  const { t } = useTranslation();
  return (
    <UnifiedAutocomplete
      mode="string"
      value={value || ''}
      onChange={onChange}
      searchFunction={searchSeries}
      placeholder={placeholder}
      debounceMs={600}
      createButtonText={(query) => t('autocomplete.useText', { item: query })}
      searchingText={t('common.searching')}
      noItemsFoundText={(query) => t('autocomplete.noSeriesFound', { item: query })}
    />
  );
};

export default SeriesAutocomplete;